import React from 'react'

import { useLogOut } from '../contexts/AuthContext'

const styles = {
  container: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
  } as const,
  content: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  logo: {
    marginBottom: '2rem',
  },
  heading: {
    fontSize: '3.75rem',
    fontWeight: 'bold',
    color: '#111827',
    margin: '1rem 0 0.5rem 0',
  },
  subheading: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#374151',
    margin: '0',
  },
  logoutButton: {
    marginTop: '1rem',
    padding: '0.625rem 1.25rem',
    fontSize: '1rem',
    color: '#666',
    backgroundColor: 'white',
    border: '1px solid #d1d5db',
    borderRadius: '0.5rem',
    cursor: 'pointer',
  },
  paragraph: {
    fontSize: '1rem',
    color: '#666',
    margin: '2rem 0 0 0',
  },
} as const

export const FourOhFour = () => {

  const handleLogOut = useLogOut()

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <svg
          width='226'
          height='79'
          viewBox='0 0 226 79'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={styles.logo}
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.4365 3.77356L20.4365 3.77358L11.047 54.7449C10.7373 56.4266 10.5824 57.2674 11.043 57.8206C11.5029 58.3729 12.3557 58.3738 14.0599 58.3738L14.0599 58.3739H47.8867L49.394 49.3592H23.2486L31.5966 0H25.7401H24.9687H23.9151L23.9142 0.00516669C22.7554 0.0242385 22.0799 0.11371 21.5758 0.533446C20.9351 1.06689 20.7689 1.96911 20.4365 3.77356ZM198.302 13.8511L190.882 58.3735H201.375L205.694 32.1992C206.022 30.3054 206.737 28.6436 207.839 27.2136C208.94 25.7643 210.283 24.6338 211.868 23.8222C213.472 23.0106 215.182 22.6048 216.998 22.6048C217.849 22.6048 218.602 22.6918 219.259 22.8657C219.936 23.0203 220.525 23.2232 221.027 23.4744L225.665 14.8366C224.989 14.3148 224.177 13.9187 223.23 13.6482C222.283 13.3583 221.221 13.2134 220.042 13.2134C217.433 13.2134 215.027 13.9187 212.824 15.3293C210.641 16.7207 208.931 18.7014 207.694 21.2715H207.23L208.477 13.8511H198.302ZM153.388 56.4608C156.306 58.3159 159.997 59.2434 164.461 59.2434C167.939 59.2434 171.098 58.7217 173.939 57.6782C176.799 56.6154 179.253 55.1274 181.301 53.2143C183.35 51.2819 184.905 49.021 185.968 46.4316L176.374 45.3302C175.678 46.5862 174.809 47.649 173.765 48.5186C172.741 49.3689 171.572 50.0066 170.258 50.4317C168.944 50.8568 167.514 51.0694 165.968 51.0694C163.61 51.0694 161.659 50.6539 160.113 49.823C158.567 48.9921 157.485 47.6973 156.866 45.9389C156.248 44.1804 156.151 41.9098 156.576 39.1272L156.602 38.9822H187.649L188.142 35.7648C188.799 31.8614 188.828 28.499 188.229 25.6777C187.63 22.8371 186.538 20.4989 184.954 18.6631C183.369 16.8273 181.427 15.4746 179.128 14.6051C176.828 13.7162 174.306 13.2717 171.562 13.2717C167.33 13.2717 163.465 14.2476 159.968 16.1993C156.49 18.1317 153.591 20.837 151.272 24.3153C148.953 27.7743 147.417 31.7937 146.663 36.3735C145.89 41.0306 146.084 45.0789 147.243 48.5186C148.422 51.939 150.47 54.5863 153.388 56.4608ZM178.693 31.9097H157.851C158.219 30.2321 158.963 28.6282 160.084 27.098C161.301 25.4361 162.799 24.0835 164.577 23.04C166.374 21.9771 168.306 21.4457 170.374 21.4457C172.403 21.4457 174.094 21.8999 175.446 22.8081C176.799 23.7163 177.765 24.9627 178.345 26.5473C178.925 28.1125 179.041 29.9 178.693 31.9097ZM116.122 62.3408L107.22 13.8516H117.945L122.582 47.5333H122.997L138.647 13.8257H149.4L121.179 73.0899C119.963 75.6437 119.355 76.9206 118.228 77.6324C117.101 78.3441 115.686 78.3441 112.858 78.3441H108.692L116.122 62.3408ZM60.2119 56.4608C62.6854 58.2579 65.6709 59.1565 69.1686 59.1565C71.7193 59.1565 73.903 58.7313 75.7194 57.8811C77.5552 57.0308 79.0721 56.0066 80.2702 54.8086C81.4876 53.5912 82.4635 52.4414 83.1978 51.3592H83.8355L82.647 58.3738H92.966L100.386 13.8514H89.8356L88.6182 21.2139H88.1834C87.8355 20.1317 87.2655 18.9819 86.4732 17.7645C85.7002 16.5278 84.5408 15.4746 82.9949 14.6051C81.4683 13.7162 79.391 13.2717 76.7629 13.2717C73.3426 13.2717 70.0961 14.1509 67.0236 15.9094C63.9704 17.6486 61.3424 20.2283 59.1394 23.6487C56.9365 27.0497 55.4196 31.2237 54.5886 36.1706C53.7964 41.0596 53.922 45.2142 54.9655 48.6346C56.009 52.0549 57.7578 54.6636 60.2119 56.4608ZM79.3716 48.7505C77.5938 49.9486 75.5938 50.5476 73.3716 50.5476C71.0527 50.5476 69.2266 49.9293 67.8932 48.6925C66.5598 47.4365 65.6806 45.7263 65.2555 43.562C64.8497 41.3784 64.869 38.8953 65.3135 36.1126C65.7772 33.3493 66.5695 30.8952 67.6903 28.7502C68.8304 26.6052 70.2701 24.9241 72.0092 23.7066C73.7484 22.4892 75.7774 21.8805 78.0963 21.8805C80.3572 21.8805 82.1833 22.4699 83.5746 23.6487C84.9659 24.8274 85.9031 26.4796 86.3862 28.6053C86.8693 30.7309 86.8693 33.2334 86.3862 36.1126C85.9031 38.9919 85.0625 41.5137 83.8645 43.678C82.6664 45.8422 81.1688 47.5331 79.3716 48.7505ZM15.3677 0.405089C14.8169 0.922941 14.6689 1.72626 14.373 3.3329L4.82587 55.16C4.54831 56.6668 4.40952 57.4202 4.80304 57.9553C4.93931 58.1406 5.11959 58.2728 5.36022 58.374H3.3154C1.60548 58.374 0.750529 58.374 0.289899 57.8208C-0.17073 57.2676 -0.0158445 56.4268 0.293927 54.7452L9.68339 3.77379C10.0158 1.96933 10.182 1.0671 10.8227 0.533657C11.4634 0.000211179 12.3808 0.000211179 14.2156 0.000211179H16.0465C15.7751 0.0998724 15.5562 0.227919 15.3677 0.405089Z'
            fill='#404040'
          />
        </svg>
        <h1 style={styles.heading}>404</h1>
        <h2 style={styles.subheading}>Demo Not Found</h2>
        <p style={styles.paragraph}>Please contact your Layer representative to get access to this demo.</p>

        <button style={styles.logoutButton} onClick={handleLogOut}>
          Log out
        </button>
      </div>
    </div>
  )
}

export default FourOhFour
